import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Loading from "react-fullscreen-loading";
import InvoicePDF from "./invoice";
import QuotationPdf from "./quotation";

const DocumentInvoice = () => {
  const [screenloader, setScreenloader] = useState(true);
  const [documentData, setDocumentData] = useState(null);
  const Param1 = useParams();
  const id = Param1.id;

  useEffect(() => {
    fetchDocumentData();
  }, []);

  const fetchDocumentData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/documents/${id}`, {
        headers: { "Access-Token": localStorage.getItem("accessToken") },
      });
      setScreenloader(false);
      setDocumentData(response.data.document);
    } catch (error) {
      setScreenloader(false);
      console.error("Failed to fetch document data:", error);
      alert("An error occurred while fetching the document.");
    }
  };


  return (
    <div >
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      {
        documentData?.type == "Quotation" ? <QuotationPdf documentData = {documentData}/> : <></>
      }

      {        
        documentData?.type == "Invoice" ? <InvoicePDF documentData = {documentData}/>: <></>
      }
    </div>
  );
};

export default DocumentInvoice;
